import { useTranslation } from 'react-i18next'
import { Constants } from '../../utils/constants'
import { Box, Icon, Typography } from '@mui/material'
import { useContextState } from '../../hooks/theme'
import { icons } from '../../utils/icons'

export const initialFilterValues = {
  role: '',
  status: '',
  search: '',
}

export const filesValidate = {
  accept: `${Constants.acceptFile.xlsx}`,
  correctTypeFile: [Constants.fileType.xlsx],
}

export const useColumnTest = () => {
  const { t } = useTranslation()
  const { colors } = useContextState()
   const styles = {
    text: {
      color: colors.color13,
      fontSize: '12px',
      wordBreak: 'break-word'
    },
    container: {
      display: 'flex',
      flexWrap: 'wrap',
      width: '100%',
      '& .w-full': {
        width: '100%'
      }
    },
    warning: {
      color: colors.color12
    }
   }
  return [
    {
      id: 'store',
      label: t('general.tags.store'),
      minWidth: 300,
      renderCell: (params: any) => {
        const row = params.row
        return (
          <Box sx={styles.container}>
            <Typography className='w-full' sx={styles.text}>{row.name}</Typography>

            <Typography className='w-full' sx={styles.text}>{row.email}</Typography>

            {row.phone && <Typography sx={styles.text}>Telefono: {row.phone}, </Typography>}

            {row.latitude && <Typography  className='w-full' sx={styles.text}>Latitud / Longitud: {row.latitude} / {row.longitude}, </Typography>}

            {row.KeyCode && <Typography sx={styles.text}>ID: {row.KeyCode}</Typography>}

            {row.address && <Typography className='w-full' sx={styles.text}>Direccion: {row.address}, </Typography>}
          </Box>
        )
      }
    },
    {
      "id": "divisionName",
      "label": "Division Name",
      minWidth: 120,
    },
    {
      "id": "zoneName",
      "label": "Zone Name",
      minWidth: 120,
    },
    {
      "id": "className",
      "label": "Class Name",
      minWidth: 120,
    },
    {
      "id": "state",
      "label": "State",
      minWidth: 120,
    },
    {
      "id": "country",
      "label": "Country",
      minWidth: 120,
    },
    {
      "id": "zipCodeId",
      "label": "Zip Code ID",
      minWidth: 120,
    },
    {
      "id": "companyName",
      "label": "Company Name",
      minWidth: 120,
    },
    {
      "id": "userManageName",
      "label": "User Manage Name",
      minWidth: 120,
    },
    {
      id: 'Errores',
      label: "",
      minWidth: 50,
      renderCell: (params:any) => {
  
        return params.current ? <Icon sx={styles.warning}>{icons('warning')}</Icon> : <></>
      }
    }
  ]

}
export const testData = [
  {
    "id": 1,
    "name": "suero costeño",
    "phone": "52556555",
    "keyCode": "10512103",
    "address": "av 5",
    "email": "mowsbbs10@gmail.com",
    "latitude": "-0.555777",
    "longitude": "25.5588",
    "companyId": 1,
    "companyName": "MACROPAY",
    "zipCodeId": 5796,
    "stateId": 4,
    "countryId": 24400,
    "state": "Campeche",
    "country": "Champotón",
    "userManageId": 318,
    "userManageName": "LUIS ALBERTO PAN AMAYA",
    "divisionId": 1,
    "divisionName": "DIVISION 1",
    "zoneId": 10,
    "zoneName": "ZONA 5",
    "classId": null,
    "className": null
  },
  {
    "id": 29,
    "name": "suero costeñossss",
    "phone": "52556555333",
    "keyCode": "1014",
    "address": "av 5ssss",
    "email": "mowsbbs10@gmail.com.co",
    "latitude": "-0.55577755",
    "longitude": "25.5588666",
    "companyId": 1,
    "companyName": "MACROPAY",
    "zipCodeId": 5796,
    "stateId": 4,
    "countryId": 24400,
    "state": "Campeche",
    "country": "Champotón",
    "userManageId": 318,
    "userManageName": "LUIS ALBERTO PAN AMAYA",
    "divisionId": 1,
    "divisionName": "DIVISION 1",
    "zoneId": 6,
    "zoneName": "ZONA 1",
    "classId": 23,
    "className": "LOW COST"
  },
  {
    "id": 2,
    "name": "",
    "phone": "",
    "keyCode": "",
    "address": "",
    "email": "",
    "latitude": "",
    "longitude": "",
    "companyId": 1,
    "companyName": "MACROPAY",
    "zipCodeId": null,
    "stateId": 4,
    "countryId": 24400,
    "state": "Campeche",
    "country": "Champotón",
    "userManageId": 320,
    "userManageName": " IVETTE GUADALUPE ALVAREZ GARCIA",
    "divisionId": 1,
    "divisionName": "DIVISION 1",
    "zoneId": 6,
    "zoneName": "ZONA 1",
    "classId": "",
    "className": "",
    "Errores": "NOMBRE_DE_UNIDAD es obligatorio, CORREO debe tener al menos 3 caracteres, CORREO es obligatorio, LATITUD es obligatorio, LONGITUD es obligatorio, ID_UNIDAD es obligatorio"
  }
]